import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
const sizes = {
    '24px': {
        hoverOverlayRadius: 12,
        innerDotRadius: 6.66667,
        outerRingRadius: 10.6667,
        strokeWidth: 2.66667,
    },
    '18px': {
        hoverOverlayRadius: 9,
        innerDotRadius: 5,
        outerRingRadius: 8,
        strokeWidth: 2,
    },
};
const RadioOptionSvg = ({ size, isDisabled = false, isSelected = false, isFocused = false, }) => {
    const dimensions = sizes[size];
    const hoverFillClass = isSelected
        ? 'group-hover:fill-light-gray'
        : 'group-hover:fill-primary-blue';
    const hoverStrokeClass = isSelected
        ? 'group-hover:stroke-light-gray'
        : 'group-hover:stroke-primary-blue';
    const hoverOpacity = isSelected ? 0.2 : 0.1;
    return (_jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: buildClassName({ 'outline-primary-blue rounded outline outline-2': isFocused }), children: _jsxs("g", { className: isDisabled ? 'text-light-gray' : isSelected ? 'text-primary-blue' : 'text-darker-gray', children: [_jsx("circle", { cx: "12", cy: "12", r: dimensions.outerRingRadius, fill: "white", stroke: "currentColor", strokeWidth: dimensions.strokeWidth }), isSelected && _jsx("circle", { cx: "12", cy: "12", r: dimensions.innerDotRadius, fill: "currentColor" }), !isDisabled && (_jsxs("g", { className: isSelected ? 'text-light-gray' : 'text-primary-blue', children: [_jsx("circle", { cx: "12", cy: "12", r: dimensions.hoverOverlayRadius, className: hoverFillClass, opacity: hoverOpacity }), _jsx("circle", { cx: "12", cy: "12", r: dimensions.outerRingRadius, stroke: hoverStrokeClass, strokeWidth: dimensions.strokeWidth, opacity: hoverOpacity })] }))] }) }));
};
export default RadioOptionSvg;
//# sourceMappingURL=RadioOptionSvg.js.map